import { formatDate } from "../utils";

export const useWalkData = (data) => {
    return data ? data[0].map(item => ({
        x: formatDate(item.timestamp),
        y: item.distance,
    })) : [];
}

export const useHrvData = (data) => {
    return data ? data[1].map(item => ({
        x: formatDate(item.date),
        y: item.hrv,
    })) : [];
}

export const useSleepScoreData = (data) => {
    return data ? data[1].map(item => ({
        x: formatDate(item.date),
        y: item.sleep_score,
    })) : [];
}

export const useSleepDurationData = (data) => {
    return data ? data[1].map(item => ({
        x: formatDate(item.date),
        y: item.sleep_duration,
    })) : [];
}

export const useCalories = (data) => {
    return data ? data[0].map(item => ({
        x: formatDate(item.timestamp),
        y: item.calories,
    })) : [];
}

export const useFineGrainedHeartRateData = (data) => {
    return data ? data.map(item => ({
        // x: formatDate(item.timestamp),
        x: item.timestamp,
        y: item.heartrate,
    })) : [];
}

export const useFineGrainedHRVData = (data) => {
    return data ? data.map(item => ({
        // x: formatDate(item.timestamp),
        x: item.timestamp,
        y: item.hrv,
    })) : [];
}

export const useFineGrainedStressData = (data) => {
    return data ? data.map(item => ({
        // x: formatDate(item.timestamp),
        x: item.timestamp,
        y: item.stress,
    })) : [];
}

export const useFineGrainedBloodPressureData = (data) => {
    return data ? data.map(item => ({
        // x: formatDate(item.timestamp),
        x: item.timestamp,
        y1: item.systolic,
        y2: item.diastolic,
    })) : [];
}